import { COMMON, ifyouApi, projectDeployServerApi, STORY } from 'apis/config';
import ErrorMessage from 'apis/ErrorMessage';

export const platformImageApi = {
  read: (designType) =>
    ifyouApi
      .post(`${STORY}/-1/com-design-select`, {
        design_type: designType,
      })
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }),
  register: (formData) =>
    ifyouApi
      .post(`${STORY}/-1/com-design-insert`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }),
  update: (formData) =>
    ifyouApi
      .post(`${STORY}/-1/com-design-update`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }),
  delete: (designId) =>
    ifyouApi
      .post(`${STORY}/-1/com-design-delete`, {
        design_id: designId,
      })
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }),
  zipUpload: (formData) =>
    ifyouApi
      .post(`${STORY}/-1/com-design-zip`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }), // deploy:
};

export const fetchCoinStoreDrop = {
  designTypeDropList: () =>
    ifyouApi
      .post(`${COMMON}`, {
        func: 'standard',
        code: 'com_design_type',
      })
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }), // deploy:
};

export const platformImageList = async (designType) => {
  try {
    const res = await ifyouApi.post(`${STORY}/-1/com-design-select`, {
      design_type: designType,
    });
    return res.data;
  } catch (error) {
    if (error.response) {
      ErrorMessage(error.response.status, error.response.data);
    }
  }
};

export const platformImageRegister = async (formData) => {
  try {
    const res = await ifyouApi.post(`${STORY}/-1/com-design-insert`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return res.data;
  } catch (error) {
    if (error.response) {
      ErrorMessage(error.response.status, error.response.data);
    }
  }
};

export const platformImageUpdate = async (formData) => {
  try {
    const res = await ifyouApi.post(`${STORY}/-1/com-design-update`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return res.data;
  } catch (error) {
    if (error.response) {
      ErrorMessage(error.response.status, error.response.data);
    }
  }
};

export const platformImageDelete = async (designId) => {
  try {
    const res = await ifyouApi.post(`${STORY}/-1/com-design-delete`, {
      design_id: designId,
    });
    return res.data;
  } catch (error) {
    if (error.response) {
      ErrorMessage(error.response.status, error.response.data);
    }
  }
};

export const platformImageZipUpload = async (formData) => {
  try {
    const res = await ifyouApi.post(`${STORY}/-1/com-design-zip`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return res.data;
  } catch (error) {
    if (error.response) {
      ErrorMessage(error.response.status, error.response.data);
    }
  }
};

export const fetchDesignTypeList = async () => {
  try {
    const res = await ifyouApi.post(`${COMMON}`, {
      func: 'standard',
      code: 'com_design_type',
    });
    // select box의 옵션 리스트에 들어간다.
    // key, value, text 값을 맞추기 위해 데이터를 재가공한다.
    const newArr: any = [];
    res?.data?.map((item, i) =>
      newArr.push({ key: i, value: item.code, text: item.code_name }),
    );

    return newArr;
  } catch (error) {
    if (error.response) {
      ErrorMessage(error.response.status, error.response.data);
    }
  }
};

export const deployByFunction = async (data) => {
  try {
    const res = await projectDeployServerApi.post(`/deploy-by-function`, {
      deploy_type: 'platform_design_only',
      project_id: '-1',
      reason: data,
    });
    return res.data;
  } catch (error) {
    if (error.response) {
      ErrorMessage(error.response.status, error.response.data);
    }
  }
};
